const getCirroLink = (shipment) => {
    if(shipment.externalShipperCode === "DHL") {
        if(["nl", "be"].includes(shipment.country.toLowerCase())){
            return `https://my.dhlecommerce.nl/home/tracktrace/${shipment.trackingNumber}/${shipment.postal.replace(" ", "%20")}`;
        } else if(["de","at"].includes(shipment.country.toLowerCase())){
            return `https://www.dhl.de/de/privatkunden/pakete-empfangen/verfolgen.html?piececode=${shipment.trackingNumber}`;
        } else {
            return `https://www.dhl.com/en/express/tracking.html?AWB=${shipment.trackingNumber}`;
        }
    }
    if(shipment.externalShipperCode === "POSTNL") {
        return `https://jouw.postnl.nl/track-and-trace/${shipment.trackingNumber}-${shipment.country}-${shipment.postal.replace(" ", "%20")}`;
    }
    if (shipment.externalShipperCode === "Colissimo") {
        return `https://www.laposte.fr/outils/track-a-parcel?code=${shipment.trackingNumber}`;
    }
    if (shipment.externalShipperCode === "correos") {
        return `https://www.correos.es/es/es/herramientas/localizador/envios/detalle?tracking-number=${shipment.trackingNumber}`;
    }
    if (shipment.externalShipperCode === "Austrian Post") {
        return `https://www.post.at/s/sendungsdetails?snr=${shipment.trackingNumber}`;
    }
    if (shipment.externalShipperCode === "InPost") {
        return `https://inpost.pl/sledzenie-przesylek?number=${shipment.trackingNumber}`;
    }
    if (shipment.externalShipperCode.toLowerCase() === "bpost") {
        return `https://track.bpost.cloud/btr/web/#/search?lang=nl&itemCode=${shipment.trackingNumber}&postalCode=${shipment.postal.replace(" ", "%20")}`;
    }
    if (shipment.externalShipperCode.toLowerCase() === "ctt express") {
        return `https://www.cttexpress.com/localizador-de-envios/?sc=${shipment.trackingNumber}`;
    }
    return `https://www.cirrotrack.com/parcelTracking?id=${shipment.externalShipperId}`
}

const getBolLink = (shipment) => {
    if(shipment.externalShipperCode === "DHL" || shipment.externalShipperCode === "DHL-SD" || shipment.externalShipperCode === "DHLFORYOU") {
        return `https://my.dhlecommerce.nl/home/tracktrace/${shipment.trackingNumber}/${shipment.postal.replace(" ", "%20")}`;
    }
    if(shipment.externalShipperCode === "POSTNL" || shipment.externalShipperCode === "TNT" || shipment.externalShipperCode === "TNT_BRIEF") {
        return `https://jouw.postnl.nl/track-and-trace/${shipment.trackingNumber}-${shipment.country}-${shipment.postal.replace(" ", "%20")}`;
    }
    return "";
}

const getMyParcelLink = (shipment) => {
    if (shipment.externalShipperName?.toLowerCase() === "postnl") {
        return `https://tracking.postnl.nl/track-and-trace/${shipment.trackingNumber}-${shipment.country.toUpperCase()}-${shipment.postal}`
    }
}

const getMyParcelComLink = (shipment) => {
    if (shipment.externalShipperCode?.toLowerCase().indexOf("postnl") > -1) {
        return `https://tracking.postnl.nl/track-and-trace/${shipment.trackingNumber}-${shipment.country.toUpperCase()}-${shipment.postal}`
    }
            
    return shipment.labelUrls?.[0] || shipment.labelUrls?.[1] || "";
}

const getInnosendLink = (shipment) => {
    // Innosend is an aggregator; the actual carrier is derived from the tracking number format.
    const trackingNumber = shipment.trackingNumber ?? "";
    const postal = shipment.postal?.replace(" ", "%20") ?? "";

    if (shipment.externalShipperName?.toLowerCase().indexOf("dpd") > -1) {
        return getDpdLink(shipment);
    }

    if (shipment.trackingUrl) {
        return shipment.trackingUrl;
    }

    // PostNL barcodes start with "3S"
    if (trackingNumber.startsWith("3S")) {
        return `https://jouw.postnl.nl/track-and-trace/${trackingNumber}-${shipment.country}-${postal}`;
    }

    // DHL eCommerce barcodes start with "JVGL"
    if (trackingNumber.startsWith("JVGL")) {
        return `https://my.dhlecommerce.nl/home/tracktrace/${trackingNumber}/${postal}`;
    }

    // GLS barcodes are numeric only
    if (/^\d+$/.test(trackingNumber)) {
        return `https://www.gls-info.nl/?trackid=${trackingNumber}&zipcode=${postal}`;
    }

    return "";
}

const getDpdLink = (shipment) => {
    const trackingNumber = shipment.trackingNumber ?? "";
    if (!trackingNumber) {
        return "";
    }

    // DPD's MyDPD tracking page is shared across countries; the country code is a path segment.
    let country;
    switch (shipment.country?.toLowerCase()) {
        case "nl":
            country = "nl";
            break;
        case "be":
            country = "be";
            break;
        case "de":
        case "at":
            country = "de";
            break;
        default:
            // Any other EU/international destination falls back to the global entry point.
            country = "com";
            break;
    }

    return `https://www.dpdgroup.com/${country}/mydpd/my-parcels/incoming?parcelNumber=${trackingNumber}`;
}

const getVinologixLink = (shipment) => {
    // VLX Flow returns no tracking url of its own; link through to the underlying carrier.
    // The shipper class fills externalShipperName with DPD / POSTNL.
    const trackingNumber = shipment.trackingNumber ?? "";
    const postal = shipment.postal?.replace(" ", "%20") ?? "";

    switch (shipment.externalShipperName?.toUpperCase()) {
        case "DPD":
            return `https://tracking.dpd.de/status/nl_NL/parcel/${trackingNumber}`;
        case "POSTNL":
            return `https://jouw.postnl.nl/track-and-trace/${trackingNumber}-${shipment.country}-${postal}`;
        default:
            return "";
    }
}

exports.getTrackingLink = (shipment) => {
    // eslint-disable-next-line default-case
    switch(shipment.shipper?.type) {
        case "dhl":
            return `https://my.dhlecommerce.nl/home/tracktrace/${shipment.trackingNumber}/${shipment.postal.replace(" ", "%20")}`;
        case "dhlgermany":
            return `https://www.dhl.de/de/privatkunden/pakete-empfangen/verfolgen.html?piececode=${shipment.trackingNumber}`;
        case "postnl": 
            return `https://jouw.postnl.nl/track-and-trace/${shipment.trackingNumber}-${shipment.country}-${shipment.postal.replace(" ", "%20")}`;
        case "dpd":
            return getDpdLink(shipment);
        case "cirro": 
            return getCirroLink(shipment);
        case "sendcloud":
            return `https://tracking.eu-central-1-0.sendcloud.sc/forward?carrier=${shipment.externalShipperName}&code=${shipment.trackingNumber}&destination=${shipment.country}&lang=en-us&source=NL&type=parcel&verification=${shipment.postal.replace(" ", "%20")}`;
        case "innosend":
            return getInnosendLink(shipment);
        case "innosendv2":
            // v2 returns a carrier tracking url per package, so there is no barcode guessing left.
            return shipment.trackingUrl ?? "";
        case "zineps":
            // Zineps is an aggregator; labels come with a carrier tracking url.
            return shipment.trackingUrl ?? "";
        case "wegrow":
            // Wegrow is an aggregator; labels come with a carrier tracking url.
            return shipment.trackingUrl ?? "";
        case "vinologix":
            return getVinologixLink(shipment);
        case "bol":
            return getBolLink(shipment);
        case "myparcel":
            return getMyParcelLink(shipment);
        case "myparcelcom":
            return getMyParcelComLink(shipment);
        case "bpost":
            return `https://www.bpost.be/en/track-trace/${shipment.trackingNumber}`;
        case "ups":
            return `https://www.ups.com/track?loc=en_NL&tracknum=${shipment.trackingNumber}`;
        case "intrapost":
            return shipment.labelUrls[0];
        case "gls":
            if (shipment.country?.toLowerCase() === "nl") {
                return `https://www.gls-info.nl/?trackid=${shipment.trackingNumber}&zipcode=${shipment.postal.replace(" ", "%20")}`;
            }
            return `https://gls-group.eu/EU/en/parcel-tracking?match=${shipment.trackingNumber}`;
        case "trunkrs":
            return `https://parcel.trunkrs.nl/${shipment.trackingNumber}/${shipment.postal.replace(" ", "%20")}`;
        case "hst":
            return `https://portal.hstonline.nl/link/tracktrace/${shipment.trackingNumber}${shipment.postal.replace(" ", "%20")}`;
        default:
            if(shipment.shipper?.type?.includes("bpost")){
                return `https://www.bpost.be/en/track-trace/${shipment.trackingNumber}`;
            }
            break;
    }
}

exports.transformShipperType = (shipperType) => {
    switch(shipperType){
        case "Colissimo":
            return "La Poste";
        default:
            return shipperType;
    }
}